import React from "react";
import "./Alert.css";

function Alert({ type = "info", message, className = "" }) {
  return (
    <div className={`alert alert-${type} ${className}`}>
      <span className="alert-icon">
        {type === "error" && "⚠️"}
        {type === "success" && "✅"}
        {type === "warning" && "⚠️"}
        {type === "info" && "ℹ️"}
      </span>
      <span className="alert-message">{message}</span>
    </div>
  );
}

export default Alert;
